import { useState, useEffect } from 'react'
import { useCanClub } from '~/hooks/components/use-can-club'
import useNotificationTopBarQuery from '~/hooks/graphql/queries/use-notification-top-bar'

const useNotificationTopBar = () => {
  const { clubDiscount } = useCanClub()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [setLoaded])

  const { notificationTopBar } = useNotificationTopBarQuery()
  const { notification, clubNotification } = notificationTopBar || {}

  return {
    loaded,
    notification: (clubDiscount && clubNotification) || notification,
  }
}

export default useNotificationTopBar
